import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Nullable } from "primereact/ts-helpers";
import "bootstrap-daterangepicker/daterangepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cookies from "js-cookie";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import AdminDashboardModal from "../../../mainMenu/adminDashboard/adminDashboardModal";

const CrmLandingPage = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const [date, setDate] = useState<Nullable<Date>>(null);
    const { userPermissions, webApi } = useUserPermissions();
    const jwtToken = Cookies.get("authToken");

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper" >
                <div className="content">
                    {/* <img
                        src="/assets/img/Youtube_CP%20copy%204@4x.png"
                        alt="Sri Chaitanya Banner"
                        style={{ width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px' }}
                    />

                    

                    <div style={{
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        maxWidth: '600px',
                        margin: '0 auto',
                    }}>
                        <h1 style={{
                            display: 'inline-block',
                            fontSize: '36px',
                            fontWeight: 'bold',
                            color: '#1e88e5',
                            animation: 'scroll-left 10s linear infinite',
                        }}>
                            Welcome to the CRM Application
                        </h1>
                    </div> */}
                </div>

                {/* Scroll animation keyframes */}
                <style>
                    {`
      @keyframes scroll-left {
        0% {
          transform: translateX(100%);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `}
                </style>
            </div>



            {/* /Page Wrapper */}
            <AdminDashboardModal />
        </>
    );
};

export default CrmLandingPage;
